import PropTypes from 'prop-types'
import React from 'react'

import { Shadow, Wrapper, DynamicImageStyled } from './styles'

const DAboutFirstBlockEuroBox = ({ path }) => (
  <Wrapper>
    <DynamicImageStyled
      image={`${path}/dna-flying-v1`}
      imageType="png"
      imageSizes={{ xs: 420, md: 490 }}
      fitOption="contain"
      alt={'DNA test kit'}
    />
    <Shadow imgUrl={`${path}/box-shadow`} />
  </Wrapper>
)

DAboutFirstBlockEuroBox.propTypes = {
  path: PropTypes.string.isRequired,
}

export default DAboutFirstBlockEuroBox
